import { defineComponent as _defineComponent } from 'vue'
import FrkNav from '@freelancerepublik/commons/ui/components/FrkNav.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FrkServerErrorLayout',
  props: {
  navbar: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return { __sfc: true,FrkNav }
}

})